(() => {
  'use strict';
  // Remove only the identified global promotion on this standalone dealer page.
  // Its existing timer may keep a reference, but the detached node cannot reopen.
  if(document.querySelector('[data-dealer-root]')){
    const removeOffer=node=>{
      if(node.nodeType!==1)return;
      if(node.id==='lv-popup2-backdrop')node.remove();
      else node.querySelectorAll?.('#lv-popup2-backdrop').forEach(offer=>offer.remove());
    };
    document.querySelectorAll('#lv-popup2-backdrop').forEach(offer=>offer.remove());
    if(typeof MutationObserver!=='undefined'){
      const observer=new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(removeOffer)));
      observer.observe(document.documentElement,{childList:true,subtree:true});
    }
  }
  document.querySelectorAll('[data-dealer-root]').forEach(root => {
    if(root.dataset.dealerReady)return;
    root.dataset.dealerReady='true';
    const application=root.querySelector('[data-partner-form]');
    const experience=application?.querySelector('[data-experience]');
    const brands=application?.querySelector('[data-brands]');
    const updateExperience=()=>{if(!brands)return;brands.hidden=experience.value!=='Yes';brands.querySelector('input').disabled=brands.hidden;};
    experience?.addEventListener('change',updateExperience);if(experience)updateExperience();
    const uses=[...root.querySelectorAll('[data-demo-use]')];
    const useSummary=root.querySelector('[data-use-summary]');
    const validateUses=()=>{
      if(!uses.length)return;
      const selected=uses.filter(el=>el.checked).map(el=>el.value);
      uses[0].setCustomValidity(selected.length?'':'Choose at least one intended use.');
      useSummary.value=selected.join('; ');
    };
    uses.forEach(el=>el.addEventListener('change',validateUses));validateUses();
    root.querySelectorAll('[data-preview-dealer]').forEach(form=>form.addEventListener('submit',event=>{
      event.preventDefault();
      const feedback=form.querySelector('[data-preview-feedback]');
      feedback.hidden=false;
      feedback.textContent=form===application?'Preview only: your application has not been sent or saved. On Shopify, applications are delivered through the store’s contact form.':'Preview only: your email has not been subscribed or saved. The Shopify version uses the “jetboat 代理商” customer tag.';
    }));
    root.querySelectorAll('[data-open-shopify-inbox]').forEach(button=>button.addEventListener('click',async()=>{
      const status=root.querySelector('[data-inbox-status]');
      const notice=message=>{if(status){status.hidden=false;status.textContent=message;}};
      if(location.hostname==='127.0.0.1'||location.hostname==='localhost'){
        notice('Preview only: online chat opens Shopify Inbox on our live store. For now, email marketing@livvoltpower.com.');
        return;
      }
      button.disabled=true;
      try{
        const chat=document.querySelector('shopify-chat');
        if(!chat)throw new Error('Inbox app embed is not present');
        let timer;
        await Promise.race([customElements.whenDefined('shopify-chat'),new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error('Inbox is still loading')),5000);})]).finally(()=>clearTimeout(timer));
        // The store's current official Shopify chat component exposes show().
        if(typeof chat.show==='function')chat.show();
        else if(chat.shadowRoot?.querySelector('button'))chat.shadowRoot.querySelector('button').click();
        else throw new Error('Inbox launcher is not ready');
        if(status)status.hidden=true;
      }catch{
        notice('Online chat is temporarily unavailable. Please email marketing@livvoltpower.com or try the store’s chat button again.');
      }finally{button.disabled=false;}
    }));
  });
})();
